import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/style.css";
import "animate.css";
import vuetify from "./plugins/vuetify";
import VueTippy, { TippyComponent } from "vue-tippy";
import "tippy.js/themes/light.css";
import "./assets/js/gtm.js";
import "./plugins/day.js";

Vue.use(VueTippy);
// or
Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false,
      },
    },
  },
});

Vue.component("tippy", TippyComponent);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
